import { component } from 'flightjs';
import WithAjax from 'tradera/legacy/static/app/data/with-ajax';
import { toLocalizedRiotUrl } from 'tradera/utils/language';

function NavigationData() {
    this.defaultAttrs({
        pageContainer: '#page-container',
        noShowError: true,
        version: null
    });

    this.navigate = function (evt, eventData) {
        this.fullPageReload(eventData.href);
    };

    this.fullPageReload = function (href) {
        window.location.href = toLocalizedRiotUrl(href);
    };

    this.doTeardown = function () {
        component.teardownAll();
    };

    this.after('initialize', function () {
        this.on(document, 'ui:navigate', this.navigate);
        this.on(document, 'ui:teardown', this.doTeardown);
    });
}

export default component(NavigationData, WithAjax);
